// NOTE: reset styles must be first so later styles can override it
// eslint-disable-next-line simple-import-sort/imports
import "../styles/reset.module.scss"
import * as RadixDropdown from "@radix-ui/react-dropdown-menu"
import classNames from "classnames"
import React from "react"
import styled from "styled-components"
import { PrimitiveBaseProps, PrimitiveWithSizing } from "../helpers/types"
import { useSizing } from "../helpers/use-sizing"

/**
 * Item
 */
interface ItemProps extends React.ComponentProps<typeof RadixDropdown.Item> {}

function DropdownItem(props: ItemProps) {
  return <RadixDropdown.Item {...props} />
}

/**
 * Trigger Item
 */
interface TriggerItemProps extends PrimitiveWithSizing, PrimitiveBaseProps<HTMLButtonElement> {
  className?: string
}

function TriggerItem(props: TriggerItemProps) {
  const {
    innerRef,
    className,
    "data-node-id": dataNodeId,
    mainAxisSizing = "hug",
    crossAxisSizing = "hug",
    ...otherProps
  } = props

  const sizingClassName = useSizing(mainAxisSizing, crossAxisSizing)

  return <div className={classNames(className, sizingClassName)} data-node-id={dataNodeId} {...otherProps} />
}

/**
 * Dropdown
 */
interface Props extends React.ComponentProps<typeof RadixDropdown.Root> {
  trigger: React.ReactNode
  children: React.ReactNode
}

const Root = styled(RadixDropdown.Root)`
  display: flex;
`

export function Dropdown(props: Props) {
  const { trigger, children, ...otherProps } = props

  return (
    <Root {...otherProps}>
      <RadixDropdown.Trigger asChild>{trigger}</RadixDropdown.Trigger>
      {children}
    </Root>
  )
}

Dropdown.Item = DropdownItem
Dropdown.Content = RadixDropdown.Content
Dropdown.TriggerItem = TriggerItem
